export class UnauthorizedResponse extends Error {
  public redirect: string
  constructor(url: string) {
    super(url)
    this.redirect = url
  }
}
